module.exports = __webpack_public_path__ + "static/media/homepage_metaverse.923b6111.mp4";